import IconCheckCircle from 'assets/icons/circle-check.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Price from '../price';

interface PropTypes {
  items: Array<any>;
  blueText?: boolean;
  /** if true it's rendered with different style */
  renderWithBox?: boolean;
}

/** Shows the sum of discount for subscription */
const Saving: React.FC<PropTypes> = ({ items, blueText, renderWithBox }) => {
  const savings = React.useMemo(() => {
    const result = {
      regularPriceTotal: items.reduce((p, c) => {
        return p + (c.compareAtPrice || c.defaultPrice) * c.quantity;
      }, 0),
      discountPriceTotal: items.reduce((p, c) => {
        return p + c.price * c.quantity;
      }, 0),
      total: 0,
    };

    result.total = result.regularPriceTotal - result.discountPriceTotal;
    return result;
  }, [items]);

  if (savings.total <= 0) {
    return null;
  }

  const savingElement = (
    <>
      {savings.total > 0 && (
        <div className="flex justify-between gap-1">
          <strong
            className={blueText ? 'text-primary-main' : 'text-text-light-bg-discounted-price'}
          >
            <FormattedMessage id="cart:savings" />
          </strong>
          <strong
            className={blueText ? 'text-primary-main' : 'text-text-light-bg-discounted-price'}
          >
            <Price value={savings.total} cents />
          </strong>
        </div>
      )}
    </>
  );

  if (renderWithBox) {
    return (
      <div className="bg-brand-soft-green-20 border-brand-soft-green mt-3 flex rounded-md border p-2 lg:mr-8 lg:justify-center">
        <IconCheckCircle className="text-brand-brilliant-green h-6 px-2" />
        {savingElement}
      </div>
    );
  }

  return savingElement;
};

export default Saving;
